import * as React from 'react';
import Box from '@mui/material/Box';
import { Button } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import "../modal.css";
import LogoRFID from "../../Imagenes/logorfid.png";
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { validate } from 'rut.js';
import EditIcon from '@mui/icons-material/Edit';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "50%",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function BasicModal({ usuarios }) {

    const URI = "https://invio.datachile.site/Web/Usuarios/ActualizarUsuario.php"
    const [id, setId] = useState(usuarios.idusuarios)
    const [nombre, setNombre] = useState(usuarios.nombre)
    const [usuario, setUsuario] = useState(usuarios.usuario)
    const [correo, setCorreo] = useState(usuarios.correo)
    const [rut, setRut] = useState(usuarios.rut)
    const [clave, setClave] = useState(usuarios.clave)
    const navigate = useNavigate()
    const [rutError, setRutError] = useState('');

    const userData = JSON.parse(localStorage.getItem('usuario'));
    const empresa_idEmpresa = userData.empresa_idEmpresa

    //procedimiento guardar
    const GuardarEditUsuario = async (e) => {
        e.preventDefault();

        // Verificar si los campos requeridos están vacíos
        if (!nombre || !rut || !clave) {
            // Mostrar mensaje de error o realizar alguna acción
            alert('Por favor, complete todos los campos');
            return;

        }

        // Validar el campo rut
        if (!validate(rut)) {
            // El RUT no es válido, mostrar mensaje de error o realizar alguna acción
            setRutError('RUT no válido');
            return;
        }

        const data = {
            id:id,
            nombre: nombre,
            correo: correo,
            usuario: usuario, // Sending 'usuario' field
            rut: rut,
            clave: clave,
            empresa_idEmpresa: empresa_idEmpresa,
        };
        console.log('Data being sent to API:', data);

        try {
            // Realizar la solicitud POST
            const res = await axios.post(URI, data);
            console.log('Response from API:', res.data);



            // Mostrar mensaje de éxito
            alert('Usuario actualizado');

            // Cerrar el modal (opcional)
            handleClose();

            // Opcional: Reiniciar los valores del formulario

            // Navegar a la página de usuarios 
            window.location.reload();

        } catch (error) {
            // Manejar errores de la solicitud POST, si es necesario
            console.error(error);
        }
    }

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div>
            <Button variant="primary" onClick={handleOpen}><EditIcon /></Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Editar Usuario
                    </Typography>

                    <Divider variant="middle" />
                    <form onSubmit={GuardarEditUsuario}>
                        <div className='input-container'>
                            <div>
                                <div className='input-container'>
                                    <TextField
                                        className='input-text'
                                        id="LabelModalRut"
                                        label="Rut"
                                        variant="outlined"
                                        defaultValue={usuarios.rut}
                                        onChange={(e) => setRut(e.target.value)}

                                        error={rutError !== ''}
                                        helperText={rutError}
                                    />
                                </div>
                                <div className='input-container'>
                                    <TextField className='input-text'
                                        id="LabelModalNombre"
                                        label="Nombre"
                                        variant="outlined"
                                        defaultValue={usuarios.nombre}
                                        onChange={(e) => setNombre(e.target.value)} />

                                    <TextField className='input-text'
                                        id="LabelModalUsuario"
                                        label="Usuario"
                                        variant="outlined"
                                        defaultValue={usuarios.usuario}
                                        onChange={(e) => setUsuario(e.target.value)} />

                                </div>
                                <div className='input-container'>
                                    <TextField className='input-text'
                                        id="LabelModalContrasena"
                                        label="Correo"
                                        type='email'
                                        variant="outlined"
                                        defaultValue={usuarios.clave}
                                        onChange={(e) => setCorreo(e.target.value)} />
                                </div>
                                <div className='input-container'>
                                    <TextField className='input-text'
                                        id="LabelModalContrasena"
                                        label="Contraseña"
                                        type='password'
                                        variant="outlined"
                                        defaultValue={usuarios.clave}
                                        onChange={(e) => setClave(e.target.value)} />
                                </div>
                                <div className="input-container">
                                    <Button type='submit' className='btn btn-primary'>Guardar</Button>
                                    <Button className="boton-container" variant="outlined" onClick={handleClose} color="error">Cancelar</Button>
                                </div>
                            </div>
                            <Divider orientation="vertical" flexItem />
                            <div>
                                <img className='tamano-imagen' src={LogoRFID} />
                            </div>
                        </div>
                    </form>
                </Box>
            </Modal>
        </div>
    );
}